export enum QualityGateType {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic',
}
